import * as React from 'react';

// Components
import { HelpSpan } from '@shopee-user/business-customization-ui';
import PageGeneric from '../PageGeneric';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Constants
import { config } from '@shopee-user/business-customization-logic';

// Styles
import styles from './style.scss';

export default function PageResetPassword({
  enableBackgroundColor = true,
}: {
  enableBackgroundColor?: boolean;
}) {
  const I18n = useTranslation();
  return (
    <PageGeneric
      className={styles.container}
      title={I18n.t('label_reset_password')}
      enableBackgroundColor={enableBackgroundColor}
      backgroundColorMobile={config.Background.ColorMobile}
      backgroundColorDesktop={config.Background.ColorDesktop}
      rightContent={<HelpSpan text={I18n.t('label_help')} />}
    />
  );
}
